// Copyright © 2021 Move Closer
import validate from 'validate.js';
import { TokenType } from '@d24/demarked';
import { RelatedType } from '../../services';
import { AbstractAdapter, getIdentifierConstraint, getRelatedTypeConstraint } from '../_abstract/adapter';
import { ModuleDriver } from '../_contracts';
import { getModuleBase } from '../_helpers/adapter';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export class ImageAdapter extends AbstractAdapter {
    /**
     * @inheritDoc
     */
    objectToToken(object, storage) {
        if (!storage) {
            throw new Error('Argument of storage should be present to [image] module');
        }
        const { content } = object;
        validate.validators.presence.message = '- [content.image] value is required, but none was provided';
        this.validate(content, {
            image: {
                presence: true,
                type: 'object'
            },
            'image.type': getRelatedTypeConstraint(RelatedType.File, true),
            'image.value': getIdentifierConstraint(true)
        });
        // Reset the error message to its default value.
        validate.validators.presence.message = undefined;
        const { caption, image } = content;
        if (!image || !image.value) {
            throw new Error('[image.value] is required, but none was provided');
        }
        // STORAGE HACK lines (53 - 76)
        // Values of keys: isAuthorChange, isCaptionChange and author (when image data isn't change) are not provided in ImageModule
        // and token is pars from ImageModule, and not form creating/editing modal this values are not provided
        // because of that there are added here from stored data.
        const old = storage.retrieve(String(image.value));
        let toStore;
        if (typeof old !== 'undefined') {
            toStore = {
                ...old,
                ...content
            };
        }
        else {
            toStore = {
                ...content
            };
        }
        if (!toStore.shortDesc) {
            toStore.shortDesc = caption;
        }
        storage.store(String(image.value), toStore);
        if (!toStore.shortDesc) {
            return {
                content: image.value,
                raw: `#PHOTO[ id: ${image.value} ]`,
                type: TokenType.Image
            };
        }
        return {
            content: image.value,
            meta: { desc: toStore.shortDesc },
            raw: `#PHOTO[ id: ${image.value} | desc: ${toStore.shortDesc} ]`,
            type: TokenType.Image
        };
    }
    /**
     * @inheritDoc
     */
    tokenToObject(token, storage) {
        if (!storage) {
            throw new Error('Argument of storage should be present to [image] module');
        }
        validate.validators.presence.message = '- either [content] is required, but none was provided';
        this.validate(token, {
            content: getIdentifierConstraint(true)
        });
        // Reset the error message to its default value.
        validate.validators.presence.message = undefined;
        const imageModule = {
            ...getModuleBase(),
            content: {},
            driver: ModuleDriver.Image
        };
        const id = token.content;
        if (typeof id === 'undefined') {
            throw new Error('[Image.adapter - tokenToObject] Image id not defined');
        }
        imageModule.content = {
            ...imageModule.content,
            image: {
                type: RelatedType.File,
                value: id
            }
        };
        const meta = storage.retrieve(String(id));
        if (typeof meta !== 'undefined') {
            const { action, author, caption, redirectExt, shortDesc } = meta;
            if (typeof author !== 'undefined') {
                imageModule.content = {
                    ...imageModule.content,
                    author
                };
            }
            if (typeof caption !== 'undefined') {
                imageModule.content = {
                    ...imageModule.content,
                    caption
                };
            }
            if (typeof shortDesc !== 'undefined') {
                imageModule.content = {
                    ...imageModule.content,
                    shortDesc
                };
            }
            if (typeof action !== 'undefined') {
                imageModule.content = {
                    ...imageModule.content,
                    action
                };
                if (action === 'link' && typeof redirectExt !== 'undefined') {
                    imageModule.content = {
                        ...imageModule.content,
                        redirectExt: redirectExt
                    };
                }
            }
        }
        return imageModule;
    }
}
